import React from 'react';
// <strong> tag fixes issue with visited link color on mso
export function LinkWrapper(props) {
    const { children, fontWeight, isRtl = false } = props;
    return (React.createElement("strong", { style: { fontWeight: fontWeight || 'normal' }, dir: isRtl ? 'rtl' : undefined }, children));
}
//# sourceMappingURL=link-wrapper.js.map